import '@theme/gsap'

const CLAIM_MOTION = {
  media: '(min-width: 768px) and (prefers-reduced-motion: no-preference)',
  start: 'center bottom',
  end: 'bottom top',
  scrub: 1,
  ease: 'power4.out'
}

/**
 * @typedef {object} ClaimMatchMedia
 * @property {(query: string, setup: () => void) => unknown} add
 * @property {() => void} revert
 */

/**
 * @param {number} _index
 * @param {HTMLElement} strip
 * @returns {number}
 */
function getStripOffset(_index, strip) {
  return -(strip.parentElement?.getBoundingClientRect().height ?? 0)
}

/**
 * @param {HTMLElement} claim
 * @param {NodeListOf<HTMLElement>} strips
 * @returns {void}
 */
function animateClaim(claim, strips) {
  window.gsap.fromTo(
    strips,
    { y: getStripOffset },
    {
      y: 0,
      ease: CLAIM_MOTION.ease,
      scrollTrigger: {
        trigger: claim,
        start: CLAIM_MOTION.start,
        end: CLAIM_MOTION.end,
        scrub: CLAIM_MOTION.scrub,
        invalidateOnRefresh: true
      }
    }
  )
}

class ManifestoClaim extends HTMLElement {
  /** @type {ClaimMatchMedia | null} */
  #media = null

  /** @returns {void} */
  connectedCallback() {
    if (this.#media || this.closest('.manifesto--static')) return
    /** @type {NodeListOf<HTMLElement>} */
    const strips = this.querySelectorAll('.manifesto__claim-strip-inner')
    if (!strips.length) return

    this.#media = window.gsap.matchMedia()
    this.#media.add(CLAIM_MOTION.media, () => animateClaim(this, strips))
  }

  /** @returns {void} */
  disconnectedCallback() {
    this.#media?.revert()
    this.#media = null
  }
}

if (!customElements.get('manifesto-claim')) {
  customElements.define('manifesto-claim', ManifestoClaim)
}
